import { JSEncrypt } from 'jsencrypt';
import { lib, AES, enc, SHA256 } from 'crypto-js';
import { environment } from 'src/environments/environment';


export class EncryptationFlagr {
  private readonly encryptor = new JSEncrypt();
  private readonly key = this.generateRandomKey();
  readonly keyEncrypt: string;

  constructor() {
    this.encryptor.setPublicKey(environment.flagr.pubKey);
    this.keyEncrypt = this.encryptWithPublicKey();
  }

  encryptSHA256(message: any): string {
    message = this.objToStr(message);
    return SHA256(message).toString();
  }

  aesEncrypt(plainText: any): string {
    plainText = this.objToStr(plainText);
    return AES.encrypt(plainText, this.key).toString();
  }

  aesDecrypt(cipherAEStext: string): string {
    return AES.decrypt(cipherAEStext, this.key).toString(enc.Utf8);
  }

  createSignature(toSign: any): string {
    const digest = this.encryptSHA256(toSign);
    return this.aesEncrypt(digest).toString();
  }

  encryptAllValuesFromObject(body: object): object {
    const bodyEnc = {};
    for (const prop in body) {
      if (body.hasOwnProperty(prop)) {
        bodyEnc[prop] = this.aesEncrypt(body[prop]);
      }
    }
    return bodyEnc;
  }

  generateRandomKey(): string {
    return lib.WordArray.random(16).toString();
  }

  private encryptWithPublicKey(): string {
    return this.encryptor.encrypt(this.key).toString();
  }

  private objToStr(object: any): string {
    return typeof object !== 'string' ? JSON.stringify(object) : object;
  }
}
